import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {ApplicationListVO, ApplicationVO} from './application.interfaces';
import {applicationDefinition, ApplicationState} from './application.reducers';
import {FullCrudFacade, PayloadWithRequestId, TerminateOnFirstExecutor} from '@abydos-angular/store';
import {ApplicationRepository} from './application.repository';

@Injectable()
export class ApplicationFacade extends FullCrudFacade<ApplicationVO, ApplicationListVO, ApplicationState> {

    constructor(store: Store<ApplicationState>, private applicationRepository: ApplicationRepository) {
        super(store, applicationDefinition);
    }

    getWithCallback(idValue: number, onSuccess: (result: ApplicationVO | null | undefined) => void) {
        new TerminateOnFirstExecutor((result: PayloadWithRequestId<ApplicationVO>) => {
            onSuccess(result.payload);
        }).run(this.applicationRepository.get(idValue));
    }

    override remove(id: number, metadata?: any): string {
        return super.remove(id, metadata);
    }

    removeWithCallback(id: number, onSuccess: (result: ApplicationVO | null | undefined) => void, metadata?: any) {
        new TerminateOnFirstExecutor((result: any) => {
            onSuccess(result);
        }).run(this.applicationRepository.remove(id));
    }
}
